// Should match those found in app/models/export_instructions.rb
export const XLSX_EXPORT_TYPE = "xlsx"
export const CSV_EXPORT_TYPE = "csv"

export const EXPORT_FILE_TYPE_OPTIONS = [
  { type: XLSX_EXPORT_TYPE },
  { type: CSV_EXPORT_TYPE, note: "(Recommended for larger data sets)" },
]
